import * as v from 'valibot';

export const IndustryResponse = v.array(
	v.object({
		category: v.string(),
		items: v.array(
			v.object({
				id: v.number(),
				name: v.string(),
				code: v.string(),
			}),
		),
	}),
);

export type IndustryResponse = v.InferOutput<typeof IndustryResponse>;
